var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.499512,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.7509C65.784 21.7509 63.867 23.5399 63.867 26.0039C63.867 28.4529 65.784 30.2569 68.136 30.2569C70.489 30.2569 72.406 28.4529 72.406 26.0039C72.405 23.5399 70.488 21.7509 68.136 21.7509ZM68.136 28.5829C66.847 28.5829 65.736 27.5199 65.736 26.0049C65.736 24.4739 66.848 23.4269 68.136 23.4269C69.425 23.4269 70.536 24.4739 70.536 26.0049C70.536 27.5189 69.425 28.5829 68.136 28.5829ZM58.822 21.7509C56.47 21.7509 54.553 23.5399 54.553 26.0039C54.553 28.4529 56.47 30.2569 58.822 30.2569C61.175 30.2569 63.092 28.4529 63.092 26.0039C63.092 23.5399 61.175 21.7509 58.822 21.7509ZM58.822 28.5829C57.533 28.5829 56.422 27.5199 56.422 26.0049C56.422 24.4739 57.534 23.4269 58.822 23.4269C60.111 23.4269 61.222 24.4739 61.222 26.0049C61.223 27.5189 60.111 28.5829 58.822 28.5829ZM47.744 23.0569V24.8609H52.062C51.933 25.8759 51.595 26.6169 51.079 27.1319C50.451 27.7599 49.468 28.4529 47.744 28.4529C45.086 28.4529 43.008 26.3099 43.008 23.6519C43.008 20.9939 45.086 18.8509 47.744 18.8509C49.178 18.8509 50.225 19.4149 50.998 20.1399L52.271 18.8669C51.191 17.8359 49.758 17.0469 47.744 17.0469C44.103 17.0469 41.042 20.0109 41.042 23.6519C41.042 27.2929 44.103 30.2569 47.744 30.2569C49.709 30.2569 51.192 29.6119 52.351 28.4039C53.543 27.2119 53.914 25.5359 53.914 24.1829C53.914 23.7649 53.882 23.3779 53.817 23.0559H47.744V23.0569ZM93.052 24.4579C92.698 23.5079 91.618 21.7509 89.411 21.7509C87.22 21.7509 85.399 23.4749 85.399 26.0039C85.399 28.3879 87.204 30.2569 89.62 30.2569C91.569 30.2569 92.697 29.0649 93.165 28.3719L91.715 27.4049C91.232 28.1139 90.571 28.5809 89.62 28.5809C88.67 28.5809 87.993 28.1459 87.558 27.2919L93.245 24.9399L93.052 24.4579ZM87.252 25.8759C87.204 24.2319 88.525 23.3949 89.476 23.3949C90.217 23.3949 90.845 23.7659 91.055 24.2969L87.252 25.8759ZM82.629 29.9999H84.497V17.4989H82.629V29.9999ZM79.567 22.7019H79.503C79.084 22.2019 78.278 21.7509 77.264 21.7509C75.137 21.7509 73.188 23.6199 73.188 26.0209C73.188 28.4049 75.137 30.2579 77.264 30.2579C78.279 30.2579 79.084 29.8069 79.503 29.2919H79.567V29.9039C79.567 31.5309 78.697 32.4009 77.296 32.4009C76.152 32.4009 75.443 31.5799 75.153 30.8869L73.526 31.5639C73.993 32.6909 75.233 34.0769 77.296 34.0769C79.487 34.0769 81.34 32.7879 81.34 29.6459V22.0099H79.568V22.7019H79.567ZM77.425 28.5829C76.136 28.5829 75.057 27.5029 75.057 26.0209C75.057 24.5219 76.136 23.4269 77.425 23.4269C78.697 23.4269 79.696 24.5219 79.696 26.0209C79.696 27.5029 78.697 28.5829 77.425 28.5829ZM101.806 17.4989H97.335V29.9999H99.2V25.2639H101.805C103.873 25.2639 105.907 23.7669 105.907 21.3819C105.907 18.9969 103.874 17.4989 101.806 17.4989ZM101.854 23.5239H99.2V19.2389H101.854C103.249 19.2389 104.041 20.3939 104.041 21.3819C104.041 22.3499 103.249 23.5239 101.854 23.5239ZM113.386 21.7289C112.035 21.7289 110.636 22.3239 110.057 23.6429L111.713 24.3339C112.067 23.6429 112.727 23.4169 113.418 23.4169C114.383 23.4169 115.364 23.9959 115.38 25.0249V25.1539C115.042 24.9609 114.318 24.6719 113.434 24.6719C111.649 24.6719 109.831 25.6529 109.831 27.4859C109.831 29.1589 111.295 30.2359 112.935 30.2359C114.189 30.2359 114.881 29.6729 115.315 29.0129H115.379V29.9779H117.181V25.1849C117.182 22.9669 115.524 21.7289 113.386 21.7289ZM113.16 28.5799C112.55 28.5799 111.697 28.2739 111.697 27.5179C111.697 26.5529 112.759 26.1829 113.676 26.1829C114.495 26.1829 114.882 26.3599 115.38 26.6009C115.235 27.7599 114.238 28.5799 113.16 28.5799ZM123.743 22.0019L121.604 27.4219H121.54L119.32 22.0019H117.31L120.639 29.5769L118.741 33.7909H120.687L125.818 22.0019H123.743ZM106.937 29.9999H108.802V17.4989H106.937V29.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.2422C47.418 11.0802 47.1701 11.7472 46.673 12.2452C46.109 12.8372 45.3731 13.1332 44.4691 13.1332C43.6031 13.1332 42.8661 12.8332 42.2611 12.2332C41.6551 11.6322 41.3521 10.8882 41.3521 10.0002C41.3521 9.11121 41.6551 8.36721 42.2611 7.76721C42.8661 7.16621 43.6031 6.86621 44.4691 6.86621C44.8991 6.86621 45.3101 6.95021 45.7001 7.11721C46.0911 7.28521 46.404 7.50821 46.6381 7.78721L46.111 8.31521C45.714 7.84021 45.167 7.60321 44.468 7.60321C43.836 7.60321 43.29 7.82521 42.829 8.26921C42.368 8.71321 42.1381 9.29021 42.1381 9.99921C42.1381 10.7082 42.368 11.2852 42.829 11.7292C43.29 12.1732 43.836 12.3952 44.468 12.3952C45.138 12.3952 45.6971 12.1722 46.1441 11.7252C46.4341 11.4342 46.602 11.0292 46.647 10.5102H44.468V9.78921H47.375C47.405 9.94621 47.418 10.0972 47.418 10.2422Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.73627H49.2961V9.63827H51.7601V10.3593H49.2961V12.2613H52.0281V12.9993H48.5251V6.99927H52.0281V7.73627Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 12.9993H54.508V7.73627H52.832V6.99927H56.955V7.73627H55.279V12.9993Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 12.9993V6.99927H60.709V12.9993H59.938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 12.9993H63.3572V7.73627H61.6812V6.99927H65.8042V7.73627H64.1281V12.9993Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.2243C73.0189 12.8303 72.2859 13.1333 71.4089 13.1333C70.5319 13.1333 69.7989 12.8303 69.2099 12.2243C68.6199 11.6183 68.3259 10.8763 68.3259 9.99926C68.3259 9.12226 68.6199 8.38026 69.2099 7.77426C69.7989 7.16826 70.5319 6.86426 71.4089 6.86426C72.2809 6.86426 73.0129 7.16926 73.6049 7.77826C74.1969 8.38726 74.4929 9.12726 74.4929 9.99926C74.4929 10.8763 74.1979 11.6183 73.6089 12.2243ZM69.7789 11.7213C70.2229 12.1713 70.7659 12.3953 71.4089 12.3953C72.0519 12.3953 72.5959 12.1703 73.0389 11.7213C73.4829 11.2713 73.7059 10.6973 73.7059 9.99926C73.7059 9.30126 73.4829 8.72726 73.0389 8.27726C72.5959 7.82726 72.0519 7.60326 71.4089 7.60326C70.7659 7.60326 70.2229 7.82826 69.7789 8.27726C69.3359 8.72726 69.1129 9.30126 69.1129 9.99926C69.1129 10.6973 69.3359 11.2713 69.7789 11.7213Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 12.9993V6.99927H76.513L79.429 11.6663H79.4619L79.429 10.5103V6.99927H80.1999V12.9993H79.3949L76.344 8.10527H76.3109L76.344 9.26127V12.9993H75.5749Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.418 10.2422C47.418 11.0802 47.1701 11.7472 46.673 12.2452C46.109 12.8372 45.3731 13.1332 44.4691 13.1332C43.6031 13.1332 42.8661 12.8332 42.2611 12.2332C41.6551 11.6322 41.3521 10.8882 41.3521 10.0002C41.3521 9.11121 41.6551 8.36721 42.2611 7.76721C42.8661 7.16621 43.6031 6.86621 44.4691 6.86621C44.8991 6.86621 45.3101 6.95021 45.7001 7.11721C46.0911 7.28521 46.404 7.50821 46.6381 7.78721L46.111 8.31521C45.714 7.84021 45.167 7.60321 44.468 7.60321C43.836 7.60321 43.29 7.82521 42.829 8.26921C42.368 8.71321 42.1381 9.29021 42.1381 9.99921C42.1381 10.7082 42.368 11.2852 42.829 11.7292C43.29 12.1732 43.836 12.3952 44.468 12.3952C45.138 12.3952 45.6971 12.1722 46.1441 11.7252C46.4341 11.4342 46.602 11.0292 46.647 10.5102H44.468V9.78921H47.375C47.405 9.94621 47.418 10.0972 47.418 10.2422Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0281 7.73627H49.2961V9.63827H51.7601V10.3593H49.2961V12.2613H52.0281V12.9993H48.5251V6.99927H52.0281V7.73627Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.279 12.9993H54.508V7.73627H52.832V6.99927H56.955V7.73627H55.279V12.9993Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.938 12.9993V6.99927H60.709V12.9993H59.938Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1281 12.9993H63.3572V7.73627H61.6812V6.99927H65.8042V7.73627H64.1281V12.9993Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6089 12.2243C73.0189 12.8303 72.2859 13.1333 71.4089 13.1333C70.5319 13.1333 69.7989 12.8303 69.2099 12.2243C68.6199 11.6183 68.3259 10.8763 68.3259 9.99926C68.3259 9.12226 68.6199 8.38026 69.2099 7.77426C69.7989 7.16826 70.5319 6.86426 71.4089 6.86426C72.2809 6.86426 73.0129 7.16926 73.6049 7.77826C74.1969 8.38726 74.4929 9.12726 74.4929 9.99926C74.4929 10.8763 74.1979 11.6183 73.6089 12.2243ZM69.7789 11.7213C70.2229 12.1713 70.7659 12.3953 71.4089 12.3953C72.0519 12.3953 72.5959 12.1703 73.0389 11.7213C73.4829 11.2713 73.7059 10.6973 73.7059 9.99926C73.7059 9.30126 73.4829 8.72726 73.0389 8.27726C72.5959 7.82726 72.0519 7.60326 71.4089 7.60326C70.7659 7.60326 70.2229 7.82826 69.7789 8.27726C69.3359 8.72726 69.1129 9.30126 69.1129 9.99926C69.1129 10.6973 69.3359 11.2713 69.7789 11.7213Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5749 12.9993V6.99927H76.513L79.429 11.6663H79.4619L79.429 10.5103V6.99927H80.1999V12.9993H79.3949L76.344 8.10527H76.3109L76.344 9.26127V12.9993H75.5749Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_20697_116898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4361 7.53784C10.1451 7.84584 9.97314 8.32384 9.97314 8.94284V31.0588C9.97314 31.6788 10.1451 32.1558 10.4361 32.4638L10.5101 32.5358L22.8991 20.1468V20.0008V19.8548L10.5101 7.46484L10.4361 7.53784Z",
    fill: "url(#paint0_linear_20697_116898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0279 24.2776L22.8989 20.1466V20.0006V19.8546L27.0289 15.7246L27.1219 15.7776L32.0149 18.5576C33.4119 19.3516 33.4119 20.6506 32.0149 21.4456L27.1219 24.2256L27.0279 24.2776Z",
    fill: "url(#paint1_linear_20697_116898)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_20697_116898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.122 24.2245L22.898 20.0005L10.436 32.4635C10.896 32.9515 11.657 33.0115 12.514 32.5255L27.122 24.2245Z",
    fill: "url(#paint2_linear_20697_116898)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.122 15.7767L12.514 7.4767C11.657 6.9897 10.896 7.0507 10.436 7.5387L22.899 20.0017L27.122 15.7767Z",
    fill: "url(#paint3_linear_20697_116898)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.499512,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#202020"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_20697_116898",
    x: 9.97314,
    y: 7.14062,
    width: 23.0894,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_20697_116898"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_20697_116898",
    result: "effect2_innerShadow_20697_116898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_20697_116898",
    x: 10.436,
    y: 20.0005,
    width: 16.686,
    height: 12.8608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_20697_116898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20697_116898",
    x1: 21.8009,
    y1: 8.70884,
    x2: 5.01895,
    y2: 25.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20697_116898",
    x1: 33.8334,
    y1: 20.0006,
    x2: 9.63753,
    y2: 20.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20697_116898",
    x1: 24.8281,
    y1: 22.2944,
    x2: 2.06964,
    y2: 45.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20697_116898",
    x1: 7.29743,
    y1: 0.176501,
    x2: 17.4597,
    y2: 10.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.e612449080c13bb299154059183917a1.svg";
export { ForwardRef as ReactComponent };